import { getApp } from 'firebase/app'
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage'
import config from 'config/config'

const MAX_DIMENSION = 1600
const JPEG_QUALITY = 0.8

// Downscale in the browser so post photos stay light (max 1600px JPEG). There is
// no server-side processing on this path — what we upload is what phones download.
export const downscaleImage = (file) =>
  new Promise((resolve, reject) => {
    const objectUrl = URL.createObjectURL(file)
    const img = new Image()
    img.onload = () => {
      URL.revokeObjectURL(objectUrl)
      const scale = Math.min(1, MAX_DIMENSION / Math.max(img.width, img.height))
      const canvas = document.createElement('canvas')
      canvas.width = Math.round(img.width * scale)
      canvas.height = Math.round(img.height * scale)
      const ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
      canvas.toBlob(
        (blob) => (blob ? resolve(blob) : reject(new Error('Could not process image'))),
        'image/jpeg',
        JPEG_QUALITY
      )
    }
    img.onerror = () => {
      URL.revokeObjectURL(objectUrl)
      reject(new Error('Could not read image'))
    }
    img.src = objectUrl
  })

// Post images live next to the community avatars in Firebase Storage — no S3/Lambda
// pipeline. Storage rules restrict writes to the uploader's own {userId} folder.
export const uploadPostImage = async ({ coachOrgId, userId, postId, file }) => {
  try {
    const blob = await downscaleImage(file)
    const storage = getStorage(getApp(), `gs://${config.firebaseConfig.storageBucket}`)
    const path = `community/${coachOrgId}/postImages/${userId}/${postId}_${Date.now()}.jpg`
    const fileRef = storageRef(storage, path)
    await uploadBytes(fileRef, blob, { contentType: 'image/jpeg' })
    const imageUrl = await getDownloadURL(fileRef)
    return { imageUrl }
  } catch (e) {
    console.error('uploadPostImage error', e)
    return { error: { message: e.message } }
  }
}
